import { PageContainer } from '@/components/ui/page-container';
import { PageHeader } from '@/components/ui/page-header';
import { IdentityEmails } from '@/components/IdentityEmails.tsx';

/**
 * Identity emails — the addresses that prove who you are.
 *
 * Deliberately not the same list as notification destinations, and worth the
 * subtitle saying so: these sign you in and recover your account, while a
 * destination only receives. The router does bridge them once — a rule naming no
 * destination mints one from your verified identity email — but that is a
 * convenience, not the two being the same thing.
 */
export default function EmailAddresses() {
  return (
    <PageContainer width="medium">
      <PageHeader
        title="Email addresses"
        subtitle="Addresses you can sign in and recover your account with"
      />
      <IdentityEmails />
    </PageContainer>
  );
}
